export default __webpack_public_path__ + "static/media/musk2.087850f1.png";